import { render, staticRenderFns } from "./AppHeaderMenu.vue?vue&type=template&id=634bf65a&scoped=true&"
import script from "./AppHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./AppHeaderMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bf65a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634bf65a')) {
      api.createRecord('634bf65a', component.options)
    } else {
      api.reload('634bf65a', component.options)
    }
    module.hot.accept("./AppHeaderMenu.vue?vue&type=template&id=634bf65a&scoped=true&", function () {
      api.rerender('634bf65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/AppHeaderMenu.vue"
export default component.exports